import { cn } from "@/lib/utils";
import type { KeyValuePairProps } from "../../pricing/price-element";
import { SummaryCollapsibleRow } from "./summary-collapsible-row";

type SummaryDiscountSectionProps = {
  label: string;
  // Aggregated discount value shown in the collapsed header (e.g. "-275,00 zł").
  total: string;
  items: KeyValuePairProps[];
  // Class overrides for embedding the row in an already-padded container, same
  // reason as on SummaryCollapsibleRow itself.
  className?: string;
  triggerClassName?: string;
  contentClassName?: string;
};

// Expandable "Rabat" section: the same discount rows as before, now collapsed
// behind a header that shows the total discount.
export const SummaryDiscountSection = ({
  label,
  total,
  items,
  className,
  triggerClassName,
  contentClassName,
}: SummaryDiscountSectionProps) => (
  <SummaryCollapsibleRow
    amount={total}
    amountClassName="text-brand-red"
    className={className}
    contentClassName={contentClassName}
    label={label}
    triggerClassName={triggerClassName}
    value="discount"
  >
    <div className="flex flex-col gap-1">
      {items.map((item) => (
        <div
          className={cn(
            "flex items-center justify-between gap-2 text-base text-brand-green1-300",
            item.className,
          )}
          key={String(item.value)}
        >
          <span className={item.labelClassName}>{item.label}</span>
          <span className={cn("font-bold text-brand-red", item.valueClassName)}>
            {item.value}
          </span>
        </div>
      ))}
    </div>
  </SummaryCollapsibleRow>
);
